export const tablePhotoFormatter = ({ id, image }) => {
  const payload = {
    gift_table: {
      // replace is a temporary trick to avoid problems with the sears waf
      image: { id, customer_image: image.replace('data:','') },
    },
    withLoader: true,
  };

  return payload;
};
